import { useMemo } from 'react'
import { Search } from 'lucide-react'
import { cn } from '@/lib/utils'

interface SearchTriggerProps {
  onClick: () => void
  className?: string
  /** Mode compact : icône seule (sidebar repliée, header mobile). */
  compact?: boolean
}

function detectMac(): boolean {
  if (typeof navigator === 'undefined') return false
  return /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent)
}

export function SearchTrigger({ onClick, className, compact = false }: SearchTriggerProps) {
  const isMac = useMemo(detectMac, [])
  const hint = isMac ? '⌘K' : 'Ctrl K'

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`Rechercher (${hint})`}
      title={`Rechercher (${hint})`}
      className={cn(
        'flex items-center gap-2 rounded-lg border bg-background/60 px-3 py-2 text-sm text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary',
        compact && 'h-8 w-8 justify-center p-0',
        className
      )}
    >
      <Search className="h-4 w-4 shrink-0" />
      {!compact && (
        <>
          <span className="flex-1 text-left group-data-[collapsible=icon]:hidden">Rechercher</span>
          <kbd className="rounded border bg-muted px-1.5 py-0.5 font-mono text-[10px] group-data-[collapsible=icon]:hidden">
            {hint}
          </kbd>
        </>
      )}
    </button>
  )
}
